const states = {
  immediateStrategyData: {},    // 紧迫性组建信息
  promptShowTime: 0,            // 后退提示窗口出现时间、
  isShowSellPrompt: false,      // 是否展示售卖页面拦截提示
  isShowPayPrompt: false,       // 是否展示付款页面拦截提示
  isShowSellCountDown: false,   // 是否展示售卖页倒计时
  isShowPayCountDown: false,    // 是否展示支付页倒计时
  sellCountDownDuring: 0,       // 售卖页倒计时剩余时间
  payCountDownDuring: 0,        // 支付页倒计时剩余时间
  sellDuring: 0,                // 售卖页倒计时后台设置时间
  payDuring: 0,                 // 支付页倒计时后台设置时间
  courseQuota: 0,               // 剩余名额
  isPhoneRoll: 0,               // 是否配置已购手机号滚动：1-是,0-否
  isLogin: false,               // 是否登陆

  // 售卖流程
  sellTypeList: [
    { value: 1, label: '常规' },
    { value: 2, label: '新一键购' },
    { value: 3, label: '微信投放' },
    { value: 4, label: '老一键购' },
    { value: 5, label: '常规一键购' },
    { value: 30, label: '分销保险' },
    { value: 31, label: '脆香米' },
    { value: 30001, label: '购物车' },
  ],

  // 支付成功引导
  guideTypeList: [
    { value: 1, label: '无' },
    { value: 2, label: '引导下载' },
    { value: 3, label: '引导加群' },
    { value: 4, label: '自定义页面' },
    { value: 5, label: '直播课加群/加老师' },
    { value: 6, label: '一元购' },
    { value: 7, label: '训练营加群/加老师' },
  ],

  // 商品预售信息
  preSaveData: null,
};
export default states;
